<template>
    <b-container fluid>
        <b-row class="app-itemtile bg-white rounded">
            <b-col cols="4" lg="3" class="d-none d-lg-block">
                <img :src="icon" />
            </b-col>
            <b-col cols="12" lg="8">
                <b-row>
                    <b-col cols="12">
                        <h3>{{ title }}</h3>
                    </b-col>
                    <b-col cols="12" lg="10">
                        <p>{{ description }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="8">
                        <slot name="button">
                            <b-button block variant="primary" @click="$emit('click')">
                                {{ action }}
                            </b-button>
                        </slot>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        action: {
            type: String,
            default: '',
        },
    },
    data: () => ({}),
    computed: {},
    methods: {},
}
</script>
<style scoped>
.app-itemtile {
    padding: 15px;
    margin-bottom: 15px;
}
</style>
